import { Role } from "@/store/apis/_shared";

/**
 * Maps a raw role string from the API to the corresponding Role enum.
 * If the role string is not recognized, defaults to Role.Usuario as a safe fallback.
 *
 * @param r - The raw role string received from the API (e.g., "Administrador", "Usuario", etc.)
 * @returns The matching Role enum value.
 */
export const mapRole = (r: string): Role => {
  switch (r) {
    case "Administrador":
      return Role.Administrador;
    case "Usuario":
      return Role.Usuario;
    case "Transportadora":
      return Role.Transportadora;
    case "Expedição":
      return Role.Expedicao;
    case "Espectador":
      return Role.Espectador;
    case "Portaria":
      return Role.Portaria;
    default:
      return Role.Usuario; // safe fallback
  }
};
